module.exports = "pegasus_template/assets/notes.png";